import { render, staticRenderFns } from "./schoolpage.vue?vue&type=template&id=fdbdf90e&scoped=true"
import script from "./schoolpage.vue?vue&type=script&lang=js"
export * from "./schoolpage.vue?vue&type=script&lang=js"
import style0 from "./schoolpage.vue?vue&type=style&index=0&id=fdbdf90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbdf90e",
  null
  
)

export default component.exports